import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import { Slider } from '@studiometa/ui';
import Header from './components/Header/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Header,
      Slider,
    },
  };
}

export default createApp(App, document.documentElement);
